import { RepeatOneSharp } from "@material-ui/icons";

const baseUrl =
  "https://cad-assets-storage-api.cloudservices.dev.mylectra.com/api";

export default function deleteGroup(group, event) {
  if (
    confirm(
      `[${group.applicationId}] [${group.groupId}]\n Suppression définitive de tous les fichiers ?`
    )
  ) {
    deleteAllAssetInGroup(group.applicationId, group.groupId)
      .then((response) => {
        console.log(response);
        if (response.ok) {
          alert(`[${group.applicationId}] [${group.groupId}]\n Suppression OK`);
          event.target.style.backgroundColor = "grey";
          event.target.disabled = true;
        } else {
          alert(
            `KO status ${response.status} : erreur dans la suppression de ${group.groupId}`
          );
        }
      })
      .catch((error) => console.warn(error));
  }
}

function deleteAllAssetInGroup(applicationId, groupId) {
  const uri = baseUrl + "/applications/" + applicationId + "/groups/" + groupId;
  //console.log("URI : " + uri);
  return fetch(uri, { method: "DELETE" });
}
